export function deepCloneWithDates<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj), (_key, value) => {
    if (typeof value === "string") {
      // Try to detect if the string is a valid ISO date format
      const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.*Z$/;
      if (dateRegex.test(value)) {
        return new Date(value);
      }
    }
    return value;
  });
}
